<template>
    <div>
        <b-table
            class="mt-2"
            responsive
            striped
            bordered
            hover
            thead-class="tcabecario"
            :items="pacientesInternados.pacienteInternado"
            :fields="colunas"
        >
            <template slot="sexoPaciente" slot-scope="row">
                <span v-if="row.item.sexoPaciente == '1'">M</span>
                <span v-if="row.item.sexoPaciente == '2'">F</span>
            </template>

            <template slot="tempoInternado" slot-scope="row">
                <div v-html="tempo(row.item.dataHoraInternacao)"></div>
            </template>
        </b-table>
    </div>
</template>

<script>
export default {
    computed: {
        pacientesInternados () {
            return this.$store.getters['relatorios/getPacientesInternados']
        },
    },
    data() {
        return {
            colunas: [
                { key: 'unidade', label: 'Unidade', class: 'text-center' },
                { key: 'cnes', label: 'CNES', class: 'text-center' },
                { key: 'codigoEnfermaria', label: 'Cód. Enfermaria', class: 'text-center' },
                { key: 'codigoLeito', label: 'Leito', class: 'text-center' },
                { key: 'nomeEnfermaria', label: 'Tipo Clínico', class: 'text-center' },
                { key: 'nomePaciente', label: 'Nome do Paciente', class: 'text-center' },
                { key: 'sexoPaciente', label: 'Sexo', class: 'text-center' },
                { key: 'dataNascimentoPaciente', label: 'Data de nascimento', class: 'text-center' },
                { key: 'idadePaciente', label: 'Idade', class: 'text-center' },
                { key: 'dataHoraInternacao', label: 'Data/Hora da Admissão', class: 'text-center' },
                { key: 'tempoInternado', label: 'Tempo Internado', class: 'text-center' },
            ],
        }
    },
    methods: {
       tempo (data) {
            if (data) {
                let dt1 = new Date(
                                    parseInt(data.substr(6,4)),
                                    (parseInt(data.substr(3,2)) - 1),
                                    parseInt(data.substr(0,2)),
                                    parseInt(data.substr(11,2)),
                                    parseInt(data.substr(14,2))
                                    )
                let dt2 = new Date()
                let resultado = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
            
                if (resultado < 15) return `<button type="button" class="btn btn-success btn-sm">${resultado} dias</button>` 
                if (resultado < 30) return `<button type="button" class="btn btn-warning btn-sm">${resultado} dias</button>` 
                if (resultado > 35) return `<button type="button" class="btn btn-danger btn-sm">${resultado} dias</button>` 
            }
        }
    },
}
</script>

<style>

</style>